import { render, staticRenderFns } from "./CardColoredBordered.vue?vue&type=template&id=3987f62a"
import script from "./CardColoredBordered.vue?vue&type=script&lang=js"
export * from "./CardColoredBordered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports